/* Guarda Mundo - Navbar glass (sem cor dinâmica por seção via IO).
 * Classes `gm-header` + `gm-header--at-top` vêm do Liquid (1º paint).
 * JS só alterna `--at-top` no scroll — CSS troca contraste (home at-top). */

(() => {
  const AT_TOP_SCROLL_PX = 16;

  const syncAtTop = () => {
    const header = document.querySelector('#header-component');
    if (!header) return;

    header.classList.add('gm-header');
    header.classList.toggle('gm-header--at-top', window.scrollY <= AT_TOP_SCROLL_PX);
  };

  const init = () => {
    syncAtTop();
    window.addEventListener('scroll', syncAtTop, { passive: true });
    window.addEventListener('resize', syncAtTop, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
